import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=d607e2a6"
import script from "./ChangeStatus.vue?vue&type=script&lang=js"
export * from "./ChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d607e2a6')) {
      api.createRecord('d607e2a6', component.options)
    } else {
      api.reload('d607e2a6', component.options)
    }
    module.hot.accept("./ChangeStatus.vue?vue&type=template&id=d607e2a6", function () {
      api.rerender('d607e2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ChangeStatus.vue"
export default component.exports